import { render, staticRenderFns } from "./TransferCards.vue?vue&type=template&id=680e5e67&scoped=true&"
import script from "./TransferCards.vue?vue&type=script&lang=js&"
export * from "./TransferCards.vue?vue&type=script&lang=js&"
import style0 from "./TransferCards.vue?vue&type=style&index=0&id=680e5e67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680e5e67",
  null
  
)

export default component.exports